module.exports = "/_next/static/images/9b27a3cd9a9528a174f6df6ccbe41c58-blog4-lg.png.webp";